<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
const props = defineProps({ open: Boolean, title: String, wide: { type: Boolean, default: false } })
const emit = defineEmits(['close'])
let onKey
onMounted(() => { onKey = e => { if (e.key === 'Escape' && props.open) emit('close') }; document.addEventListener('keydown', onKey) })
onBeforeUnmount(() => document.removeEventListener('keydown', onKey))
</script>

<template>
  <teleport to="body">
    <div v-if="open" class="drawer-overlay" @click="$emit('close')"></div>
    <div v-if="open" class="drawer" :class="{ wide }" role="dialog" aria-modal="true">
      <div class="drawer-header">
        <h3>{{ title }}</h3>
        <button class="drawer-close" @click="$emit('close')" aria-label="Close">
          <span style="font-size:20px;line-height:1;">&times;</span>
        </button>
      </div>
      <div class="drawer-body"><slot /></div>
    </div>
  </teleport>
</template>
